const locations = location.host;
//const location = 'glavstroi';

import Vue from 'vue';
import Vuetify from 'vuetify';
import VueResource from 'vue-resource';
import yaMaps from 'vue-yandex-maps';

import App from './App.vue';

import { router } from './router/router';
import { store } from './store/store';

import directives from './system/directives.js';
import filters from './system/filters.js';

Vue.use(VueResource);
Vue.use(Vuetify);
Vue.use(yaMaps);

Vue.config.productionTip = false;
Vue.http.options.root = '/api/v4/';

Vue.http.interceptors.push(function(request, next) {

    request.params['org'] = locations;


  if (request.url=="https://lk.eis24.me/api/v2/auth/login/"){
        request.params={};
         // request.crossOrigin=false;
    }

    next();
});

new Vue({
    el: '#app',
    store,
    router,
    data() {
        return {
            locations
        }
    },
    render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/app.js